import axios from 'axios';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { userSelector } from '../../../../appStore/commonSlice';
import { getRequisitoPublicosPorPuesto } from '../../../../appStore/denominaciones';
import { postInscribirse, useInscripciones } from '../../../../appStore/inscripciones';
import { AppDispatch } from '../../../../appStore/store';
import { CVAPI, USERAPI } from '../../../../const';
import { CardModal } from '../../../CompUtils/CardModal';
import FullLoading from '../../../CompUtils/FullLoading';
import { SuccessErrorDlg } from '../../../CompUtils/SuccessErrorDlg';
import { ModalCargaBasesYCondiciones } from '../../Gestion/TramitarConcursos/Commons/PuestosTable/ModalCargaBasesYCondiciones';
import { PuestoProps } from '../../Gestion/TramitarConcursos/Commons/PuestosTable/PuestoRow';
import { usePuestoTableConfig } from '../../Gestion/TramitarConcursos/Commons/PuestosTable/PuestosTableProvider';
import { Step1AndStep2ToPrint } from './Step1AndStep2ToPrint';
import Step1Requisitos from './Step1Requisitos';
import Step2Terminos from './Step2Terminos';

type RequisitoLlamadoConcurso = {
  descripcion: string;
  idRequisitoLlamadoConcurso: number;
  nombre: string;
  requerido: boolean;
};
type Props = {
  open: boolean;
  onClose: () => void;
  requisitoGeneral: RequisitoLlamadoConcurso;
  concurso: any;
  requisitos: any;
  setRequisitos: (requisitos: any) => void;
} & Partial<PuestoProps>;

const HorizontalDiv = styled.div`
  display: flex;
  justify-content: center;
`;
const FormRoot = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
`;

const BtnRoot = styled.div`
  display: flex;
  justify-content: center;
`;

export const InscripcionPopup = (props: Props) => {
  const { requisitoGeneral, requisitos, setRequisitos, onClose, open, ...puesto } = props;
  const { withActions } = usePuestoTableConfig();
  const [showCargaBasesModal, setShowCargaBasesModal] = useState(false);

  const {
    concurso,
    idPuesto,
    pathBbyccPuesto,
    idLlamadoConcurso,
    ubicacionEstructural,
    denominacion,
  } = puesto;
  const [userData, setUserData] = useState<any>({});
  const user = useSelector(userSelector);
  useEffect(() => {
    axios
      .get(`${USERAPI}/usuarios/cuil/${user?.cuil}`)
      .then((res) => {
        setUserData(res.data);
      })
      .catch((err) => console.error(err));
  }, []);
  const dispatch = useDispatch<AppDispatch>();
  const history = useHistory();
  const [idPuestoRecuperado, setIdPuestoRecuperado] = useState<number | undefined>(puesto.idPuesto);
  const [requisitoConcursoSt] = useState(requisitoGeneral);
  const [enabledButtonAceptar, setEnabledButtonAceptar] = useState(false);
  const { success, message, fail, error } = useInscripciones();
  const [isLoading, setIsLoading] = useState(false);
  const [toPrint, setToPrint] = useState<boolean>(false);
  const [tieneCV, setTieneCV] = useState(false);
  const handleAfterPrint = useCallback(() => {
    // idPuestoRecuperado && dispatch(getBasesPuestoPublicas({ idPuesto: idPuestoRecuperado }));
    handleClose();
  }, []);

  const handleSubmitStep1 = () => {
    if (step === 1) {
      nextStep();
    }
  };

  const handleSubmitStep2 = async () => {
    if (step === 2) {
      setEnabledButtonAceptar(false);
      setIsLoading(true);
      let requisitosConcurso = new Array(1);
      requisitosConcurso.pop();
      requisitosConcurso.push({
        idRequisitoLlamadoConcurso: requisitoConcursoSt.idRequisitoLlamadoConcurso,
        cumple: true,
      });

      //preparo array con los requisitos
      let requisitosPuestos = new Array();
      for (let [k, v] of Object.entries(requisitos)) {
        requisitosPuestos.push({
          cumple: v ? true : false,
          idRequisitoPuesto: k,
          presentoDocumentacion: false,
        });
      }
      //preparo los datos de la request
      let datosInscripcion = {
        idUsuario: user?.id as number,
        idPuesto: idPuestoRecuperado,
        datosInscripcion: {
          datosPostulante: {
            observaciones: '',
            pseudonimo: '',
          },
          requisitosPuestoDeclarados: requisitosPuestos,
          requisitosLlamadoConcursoDeclarados: requisitosConcurso,
        },
      };

      try {
        const resultAction = await dispatch(postInscribirse(datosInscripcion));
        if (postInscribirse.fulfilled.match(resultAction)) {
          // Status code is in the 2xx range
          setToPrint(true);
          handlePrint();
          handleClose();
        } else {
          // Status code is not in the 2xx range
          handleClose();
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleClose = useCallback(() => {
    setStep(1);
    setEnabledButtonAceptar(false);
    onClose();
  }, []);

  useEffect(() => {
    if (idPuesto) {
      dispatch(getRequisitoPublicosPorPuesto({ idPuesto }));
      setIdPuestoRecuperado(idPuesto);
    }
  }, [dispatch, idPuesto]);
  useEffect(() => {
    if (success || fail) {
      setIsLoading(false);
      setEnabledButtonAceptar(true);
    }
  }, [success, fail]);
  const [showError, setShowError] = useState(fail);

  useEffect(() => {
    setEnabledButtonAceptar(false);
    setShowError(fail);
  }, [fail]);

  useEffect(() => {
    if (!user || !user.cuil) return;
    axios.get(`${CVAPI}/curriculum?usuario=${user.id}`).then((res) => {
      setTieneCV(res.data.length > 0);
    });
  }, []);

  const validarRequisitos = () => {
    return Object.values(requisitos).some((value) => value == null);
  };

  const [step, setStep] = useState<number>(1);
  const nextStep = () => {
    setStep(step + 1);
  };

  const componentRef = useRef(null);
  const reactToPrintContent = useCallback(() => {
    return componentRef.current;
  }, [componentRef.current]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: `${userData.nombre}_${userData.apellido}_${
      userData.cuil
    }_${denominacion}_${ubicacionEstructural}_${new Date().toLocaleDateString()}`,
    removeAfterPrint: true,
    onAfterPrint: handleAfterPrint,
    pageStyle: `
    @media print {
      .no-print {
        display: none !important;
      }
    }
  `,
  });

  return (
    <>
      <FullLoading show={isLoading} />
      <CardModal
        open={open}
        onClose={() => {
          handleClose();
        }}
        title="Inscripción"
        subtitle={denominacion}>
        {open && (
          <>
            <FormRoot>
              {step === 1 ? (
                <Step1Requisitos
                  requisitos={requisitos}
                  setRequisitos={setRequisitos}
                  handleSubmitStep1={handleSubmitStep1}
                  enabledButtonAceptar={validarRequisitos()}
                  tieneCV={tieneCV}
                />
              ) : (
                <>
                  <Step2Terminos handleSubmitStep2={handleSubmitStep2} />
                  <div style={{ display: toPrint ? '' : 'none', visibility: 'hidden' }}>
                    <Step1AndStep2ToPrint
                      puesto={puesto}
                      concurso={concurso}
                      ref={componentRef}
                      idLlamadoConcurso={idLlamadoConcurso}
                      ubicacionEstructural={ubicacionEstructural}
                      requisitos={requisitos}
                      setRequisitos={setRequisitos}
                    />
                  </div>
                </>
              )}
            </FormRoot>
            {!tieneCV && (
              <HorizontalDiv>
                <p
                  className="d-flex justify-content-center w-100 h-50 text-danger"
                  style={{ fontSize: 12 }}>
                  Debes completar el CV antes de postularte
                </p>
              </HorizontalDiv>
            )}
            <BtnRoot>
              <Button onClick={handleClose} className="mr-4" variant="link">
                Cancelar
              </Button>
              {step === 2 && (
                <Button
                  onClick={() => {
                    setStep(1);
                  }}
                  className="mr-4"
                  variant="link">
                  Volver
                </Button>
              )}

              {!tieneCV && (
                <Link to="/cv">
                  <Button variant="success">Ir al CV</Button>
                </Link>
              )}
            </BtnRoot>
          </>
        )}
      </CardModal>

      {success && (
        <SuccessErrorDlg
          error={''}
          success={message}
          onClose={() => {
            history.go(0);
          }}
        />
      )}
      {showError && (
        <SuccessErrorDlg
          error={error}
          success={''}
          onClose={() => {
            setShowError(false);
          }}
        />
      )}
      <ModalCargaBasesYCondiciones
        idPuesto={idPuesto}
        pathBases={pathBbyccPuesto}
        withActions={withActions}
        showCargaBasesModal={showCargaBasesModal}
        handleCloseModal={() =>
          setShowCargaBasesModal(!showCargaBasesModal)
        }></ModalCargaBasesYCondiciones>
    </>
  );
};
